<template>
  <div class="comment" :class="{ commentIsIosx: isIosx }">
    <van-sticky>
      <div class="commentNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">评价</span>
      </div>
    </van-sticky>
    <div class="commentContent">
      <div class="commentContentTop">
        <img :src="image" />
        <p>{{ title }}</p>
      </div>
      <div class="commentContentBtm">
        <div class="rate">
          <p>
            <span v-if="score == 0">—— 课程学习感受 ——</span>
            <span v-else>“{{score+'.0分'}}，{{ scoreText }}”</span>
          </p>
          <div>
            <div @click="selectScore(1, '略感失望')">
              <img
                src="./../../assets/school/22f.png"
                v-if="score == 1"
                class="selected"
              />
              <img
                src="./../../assets/school/2f.png"
                v-else
                class="unselected"
              />
              <span :class="{ check: score == 1 }">略感失望</span>
            </div>
            <div @click="selectScore(2, '毫无出彩')">
              <img
                src="./../../assets/school/11f.png"
                v-if="score == 2"
                class="selected"
              />
              <img
                src="./../../assets/school/1f.png"
                v-else
                class="unselected"
              />
              <span :class="{ check: score == 2 }">毫无出彩</span>
            </div>
            <div @click="selectScore(3, '感觉一般')">
              <img
                src="./../../assets/school/33f.png"
                v-if="score == 3"
                class="selected"
              />
              <img
                src="./../../assets/school/3f.png"
                v-else
                class="unselected"
              />
              <span :class="{ check: score == 3 }">感觉一般</span>
            </div>
            <div @click="selectScore(4, '值得学习')">
              <img
                src="./../../assets/school/44f.png"
                v-if="score == 4"
                class="selected"
              />
              <img
                src="./../../assets/school/4f.png"
                v-else
                class="unselected"
              />
              <span :class="{ check: score == 4 }">值得学习</span>
            </div>
            <div @click="selectScore(5, '大力推荐')">
              <img
                src="./../../assets/school/55f.png"
                v-if="score == 5"
                class="selected"
              />
              <img
                src="./../../assets/school/5f.png"
                v-else
                class="unselected"
              />
              <span :class="{ check: score == 5 }">大力推荐</span>
            </div>
          </div>
        </div>
        <van-field
          v-model="content"
          rows="4"
          autosize
          type="textarea"
          placeholder="请输入评价内容"
          show-word-limit
          @click="setfocus()"
          ref="textareaIpt"
        />
        <span @click="submit()" v-if="isToken">评价</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isIosx: false,
      isToken: false,
      title: "",
      image: "",
      id: 0,
      score: 0,
      scoreText: "",
      content: "",
    };
  },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
    }
    if (this.$route.query.image) {
      this.image = this.$route.query.image;
    }
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.isToken = true;
    } else {
      this.isToken = false;
    }
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    selectScore(score, scoreText) {
      this.score = score;
      this.scoreText = scoreText;
    },
    submit() {
      this.$api
        .post("school/member/create/comment", {
          content: this.content, //类型：String  必有字段  备注：内容
          score: this.score, //类型：Number  必有字段  备注：评分
          courses_id: this.id, //类型：Number  必有字段  备注：课程id
        })
        .then((res) => {
          this.$toast("评价成功！");
          this.prev();
        })
        .catch((res) => {
          this.$toast(res.message);
        });
    },
    setfocus() {
      this.$refs.textareaIpt.focus();
    },
  },
};
</script>
<style>
.comment {
  height: 100%;
  background-color: #f7f8fc;
}
.commentNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.commentNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.commentNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
/* content */
.commentContent {
  margin: 0 16px;
}
.commentContentTop {
  height: 68px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.commentContentTop img {
  width: 60px;
  height: 40px;
  border-radius: 4px;
  margin-right: 6px;
}
.commentContentTop p {
  font-size: 15px;
  font-weight: 700;
  color: #404247;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.commentContentBtm {
  background: #ffffff;
  border-radius: 8px;
  padding: 1px 16px 64px;
}
.commentContentBtm .rate {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 36px 0 32px;
}
.commentContentBtm .rate p {
  font-size: 14px;
  color: #9ca1ad;
  margin-bottom: 24px;
}
.commentContentBtm .rate > div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.commentContentBtm .rate > div > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.commentContentBtm .rate > div > div span {
  font-size: 11px;
  font-weight: 400;
  color: #cacde0;
  line-height: 16px;
  margin-top: 6px;
}
.commentContentBtm .selected {
  height: 40px;
  width: 40px;
}
.commentContentBtm .unselected {
  width: 32px;
  height: 32px;
}
.commentContentBtm .rate > div > div .check {
  font-size: 12px;
  font-weight: 600;
  color: #404247;
  line-height: 17px;
}

.commentContentBtm .van-field {
  width: 100%;
  height: 252px;
  background: #f6f8fd;
  border-radius: 8px;
  border: none;
  padding: 16px;
  overflow: auto;
  font-size: 15px;
}
.commentContentBtm .van-cell__value {
  width: 100%;
}
.commentContentBtm > span {
  display: block;
  height: 40px;
  background: linear-gradient(90deg, #86b4fc 0%, #4e7df7 100%);
  border-radius: 20px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin-top: 24px;
}

.commentIsIosx .commentNav {
  padding-top: 44px;
}
</style>>